import { IntelligenceEventType, OfferSuggestionStreamEvent } from '../../../../common/api/clients/intelligence.api';
import { translate } from '../../../../common/helpers/translate.helper';
import { IntelligenceProgressIndicator } from '../../../create-enquiry/components/intelligence/IntelligenceProgressIndicator';

interface OfferReviewProgressIndicatorProps {
    events: OfferSuggestionStreamEvent[];
}

export const OfferReviewProgressIndicator = ({ events }: OfferReviewProgressIndicatorProps) => {
    const eventData = events.map((event) => event.data);
    const eventTypes = events.map((event) => event.event);

    const gatheringFinished = eventData.includes('FETCHING_DATA_FINISHED');
    const reviewingStarted = eventData.includes('CALLING_LLM_STARTED');
    const reviewingFinished = eventData.includes('CALLING_LLM_FINISHED');

    const hasLLMUpdates = eventTypes.includes(IntelligenceEventType.LLM_UPDATE);

    const gatheringActive = !gatheringFinished && !hasLLMUpdates;
    const reviewingActive = reviewingStarted && !reviewingFinished && !hasLLMUpdates;
    const formulatingActive = hasLLMUpdates && !reviewingFinished;

    const steps = [
        {
            text: translate('closelinkInsights.offerReview.gatheringInformation'),
            description: translate('closelinkInsights.offerReview.gatheringInformation.description'),
            isActive: gatheringActive,
            isVisible: true,
        },
        {
            text: translate('closelinkInsights.offerReview.reviewingOffers'),
            description: translate('closelinkInsights.offerReview.reviewingOffers.description'),
            isActive: reviewingActive,
            isVisible: reviewingStarted,
        },
        {
            text: translate('closelinkInsights.offerReview.generatingRecommendation'),
            isActive: formulatingActive,
            isVisible: hasLLMUpdates,
        },
    ];

    return <IntelligenceProgressIndicator steps={steps} />;
};
